import { API as e, Resource as t } from "@coveo/platform-client";
//#region src/resources/MCPConfigurationsResource.ts
var n = class n extends t {
	static {
		this.baseUrl = `/api/private/organizations/${e.orgPlaceholder}/mcp/configurations`;
	}
	list(e) {
		return this.api.get(this.buildPath(n.baseUrl, e));
	}
	get(e) {
		return this.api.get(`${n.baseUrl}/${e}`);
	}
	createBasic(e) {
		return this.api.post(`${n.baseUrl}/create-basic`, e);
	}
	update(e, t) {
		return this.api.put(`${n.baseUrl}/${e}`, t);
	}
	delete(e) {
		return this.api.delete(this.buildPath(`${n.baseUrl}/${e}`));
	}
	setAsDefault(e) {
		return this.api.put(this.buildPath(`${n.baseUrl}/${e}/set-as-default`));
	}
	getDefaultValues() {
		return this.api.get(`${n.baseUrl}/default-values`);
	}
};
//#endregion
export { n as MCPConfigurationsResource };

//# sourceMappingURL=MCPConfigurationsResource.js.map